import type { VerySlimCarrier, Workflow } from '@fv/models'

import { useStaticDataQuery } from '@/hooks/useStaticDataQuery'
import { shipperFetch } from '@/utils/shipperFetch'

const fetchCarrierList = async (workflow: Workflow) =>
  shipperFetch<VerySlimCarrier[]>(`/carriers/list`, {
    query: { workflow },
  })

export function useCarrierList(workflow: Workflow) {
  return useStaticDataQuery(
    ['carrier-list', workflow],
    () => fetchCarrierList(workflow),
    {
      select: data =>
        data.slice().sort((a, b) => {
          const aName = a.name.trim().toLocaleLowerCase()
          const bName = b.name.trim().toLocaleLowerCase()
          return aName.localeCompare(bName)
        }),
    },
  )
}
